import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	resultLabel: {
		id: 'dynamic-cards-search-page.github-commit-result.label',
		defaultMessage: 'Commit',
		description: 'GitHub commit label',
	},
});
